import axios from '../axios'

/**
 * 文件上传API模块
 */
const fileAPI = {
  /**
   * 上传文件
   * @param {File} file - 要上传的文件对象
   * @returns {Promise} - 返回上传结果
   */
  uploadFile: async (file) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      
      const response = await axios.post('/files/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      return response
    } catch (error) {
      console.error('文件上传失败:', error)
      throw error
    }
  }
}

export default fileAPI